import { ChangeDetectionStrategy, Component, Inject, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { SelectOption } from '../../../../shared/models/select-option'; // Adjust the path as necessary
import { ControlPoint } from '../../../../shared/models/controlPoint';
import { Site } from '../../../../shared/models/site';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AutocompleteComponent } from '../../../../shared/components/autocomplete/autocomplete.component'; // Adjust the path as necessary
import { ControlPointModaleComponent } from '../control-point-modale/control-point-modale.component';
import { TransformedCoords } from '../../../../shared/models/transformed-coords';
import { LocalStorageService } from '../../../../shared/services/utilities/local-storage.service';
import { ConfirmDialogComponent } from '@shared/components/confirm-dialog/confirm-dialog.component';
import { ControlPointsService } from '@features/control-points/services/control-points-service';
import { FonctionsService } from '@shared/services/utilities/fonctions.service';
import { SeismographService } from '@features/seismograph-devices/services/seismograph-service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Seismograph } from '@shared/models/seismograph';
import { Company } from 'app/core/models/company';
import { CurrentStateService } from 'app/core/services/current-state.service';
import { MENU_OPTIONS } from '@shared/constants/left-menu-option';

@Component({
  selector: 'app-control-point-detail',
  imports: [TranslateModule, MatIconModule, CommonModule, AutocompleteComponent],
  templateUrl: './control-point-detail.component.html',
  styleUrl: './control-point-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ControlPointDetailComponent implements OnInit {

  constructor(private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogConfirme: MatDialog,
    private localStorageService: LocalStorageService,
    private controlPointService: ControlPointsService,
    private fonctionsService: FonctionsService,
    private seismographService: SeismographService,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService, private currentStateService: CurrentStateService) {
    this.transformedCoords = this.localStorageService.getItem('cp-transformedCoords');
  }

  showCurrentDevice = true;
  device: Seismograph = null;
  company: Company = null;
  optionsDevice: SelectOption[] = [];
  selectedDevice: Seismograph = null;
  seismographDevices: Seismograph[] = [];

  isDeviceSelected = false;
  companies: Company[] = [];
  isLoading = false;
  isEditing: boolean = false;

  async ngOnInit(): Promise<void> {
    this.companies = await this.seismographService.getAllCompanies();
    await this.controlPointService.getControlPointsBySiteId(this.site?.siteId, true);
    await this.loadDeviceName();
    this.seismographDevices = await this.seismographService.getAllSeismographs();
    this.imageUrl = this.localStorageService.getItem('map-image-url');
    this.cdr.detectChanges();
    (async () => {
      try {
        let allDevices = await this.seismographService.getAllSeismographs();
        this.optionsDevice = allDevices.filter(x => x.controlPointId == undefined || x.controlPointId == null).map(device => ({
          id: device.id,
          name: device.serialNumber
        }));
      } catch (err) {
        console.error('Failed to fetch seismographs:', err);
      }
    })();
  }

  @Input() controlPoint: ControlPoint
  @Input() site: Site;
  @Input() numeroContolPoint: number;
  transformedCoords: TransformedCoords;
  imageUrl: string = '';
  onModifyVibrationCp() {
    this.controlPoint.x = this.transformedCoords.x;
    this.controlPoint.y = this.transformedCoords.y;
    const dialogRef = this.dialogConfirme.open(ControlPointModaleComponent,
      {
        data: { currentControlPoint: this.controlPoint, currentSite: this.site, device: this.device },
        enterAnimationDuration: '0ms',
      },

    );

    dialogRef.afterClosed().subscribe(() => {
      this.updateCurrentControlPoint();
    });
  }

  updateCurrentControlPoint(): void {

  }

  onDelete() {
    const dialogRef = this.dialogConfirme.open(ConfirmDialogComponent, {
      enterAnimationDuration: '0ms',
      data: { title: 'Delete Control Point', message: 'Are you sure you want to delete this Control Point?' },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteControlPoint();
      }
    });
  }

  deleteControlPoint() {
    this.controlPointService.deleteControlPoint(this.site.siteId, this.controlPoint.controlPointId).subscribe({
      next: () => {
        this.router.navigate(['/'], { queryParams: { controlPointId: this.controlPoint.controlPointId, siteId: this.site.siteId } });
        this.translate.get('SUCCESS.CONTROL_POINT_DELETED').subscribe((translatedMessage: string) => {
          this.fonctionsService.launch_toast(true, translatedMessage);
        });
      },
      error: (err) => {
        this.translate.get('ERRORS.CONTROL_POINT_DELETE_ERROR').subscribe((translatedMessage: string) => {
          this.fonctionsService.launch_toast(false, translatedMessage);
        });
      }
    })
  }


  backToEventList(): void {
    this.router.navigate(['/'], { queryParams: { controlPointId: this.controlPoint.controlPointId, siteId: this.site.siteId } });
  }
  goToMap(): void {
    this.router.navigate(['/']);
  }

  navigateToVibrationDetail(): void {
    if (this.device?.serialNumber && this.site) {
      this.router.navigate(['/'], {
        queryParams: {}
      });
      this.currentStateService.toggleSlideMenu(null, MENU_OPTIONS.DEVICES);
      this.currentStateService.setCurrentMenu(MENU_OPTIONS.DEVICES);
      this.localStorageService.setItem('currentMenu', MENU_OPTIONS.DEVICES);
      setTimeout(() => {
        this.router.navigate(['/vibration-detail'], {
          queryParams: { deviceId: this.device.serialNumber, siteId: this.site.siteId}
        });
      }, 1);
    }
  }

  async loadDeviceName(): Promise<void> {
    if (!this.controlPoint?.controlPointId) {
      return;
    }
    const controlPointInstrument = await this.seismographService.getSeismographsByControlPointIds([this.controlPoint.controlPointId]);

    if (controlPointInstrument.length === 0) {
      return;
    }

    this.device = controlPointInstrument[0].seismograph;

    const companyInstruments = await this.seismographService.getCompanyInstrumentsBySeismographIds([this.device.id]);
    const companyInstrument = companyInstruments?.[0] || null;

    this.company = this.companies.find(c => c.id === companyInstrument?.companyId) || null;
  }

  toggleCurrentDevice() {
    this.showCurrentDevice = !this.showCurrentDevice;
    if (!this.showCurrentDevice && this.isDeviceSelected) {
      this.isEditing = false;
      this.resetSelection();
    }
  }

  private filterDevices(value: string): Seismograph[] {
    if (!value?.trim()) {
      return [];
    }

    const filterValue = value.trim().toLowerCase();

    try {
      return this.seismographDevices.filter((device): device is Seismograph => {
        const serialNumber = (device.serialNumber ?? '').toLowerCase();
        const model = (device.model ?? '').toLowerCase();
        return serialNumber.includes(filterValue) || model.includes(filterValue);
      });
    } catch (error) {
      console.error(this.translate.instant('ERRORS.DEVICE_FILTER_ERROR'), {
        error,
        filterValue,
        deviceCount: this.seismographDevices.length
      });
      return [];
    }
  }

  onDeviceSelect(device: Seismograph): void {
    this.selectedDevice = device;
    this.isDeviceSelected = true;
    this.cdr.detectChanges();
  }

  resetSelection(): void {
    this.selectedDevice = null;
    this.isDeviceSelected = false;
    this.cdr.detectChanges();
  }

  async assignDeviceToCp(): Promise<void> {
    if (!this.selectedDevice?.id || !this.controlPoint?.controlPointId) {
      this.translate.get('ERRORS.INVALID_DEVICE_SELECTION').subscribe((translatedMessage: string) => {
        this.fonctionsService.launch_toast(false, translatedMessage);
      });
      return;
    }

    try {
      this.isLoading = true;

      if (this.isEditing && this.device && this.device.id !== this.selectedDevice.id) {
        await this.seismographService.deleteControlPointInstrument(this.controlPoint.controlPointId, this.device.id);
      }

      await this.seismographService.createControlPointInstrument(
        this.controlPoint.controlPointId,
        this.selectedDevice.id,
        this.controlPoint.name
      );

      await this.loadDeviceName();
      this.translate.get(this.isEditing ? 'SUCCESS.DEVICE_UPDATED' : 'SUCCESS.DEVICE_ASSIGNED').subscribe((translatedMessage: string) => {
        this.fonctionsService.launch_toast(true, translatedMessage);
        this.isEditing = false;
        this.resetSelection();
      });
    } catch (error) {
      const errorKey = this.isEditing ? 'ERRORS.DEVICE_UPDATE_ERROR' : 'ERRORS.DEVICE_ASSIGN_ERROR';
      this.translate.get(errorKey).subscribe((translatedMessage: string) => {
        this.fonctionsService.launch_toast(false, translatedMessage)
      });
    } finally {
      this.isLoading = false;
      this.cdr.markForCheck();
    }
  }

  onEditDevice(): void {
    this.isEditing = true;
    this.showCurrentDevice = true;
    if (this.device) {
      this.selectedDevice = this.device;
    }
  }

  onOptionDeviceSelected(device: any) {
    this.selectedDevice = device;
  }

  cancelModifyAssignedDevice() {
    this.isEditing = false;
    this.showCurrentDevice = false;
  }
}
